module.exports = __webpack_public_path__ + "img/address.10d7e91d.png";